const pkg = state => state.pkg;
const app = state => state.app;
const device = state => state.app.device;
const sidebar = state => state.app.sidebar;
const effect = state => state.app.effect;
const menuitems = state => state.menu.items;
const currency = state => state.app.currency;
const tag = state => state.app.tag;
const componententry = state => {
  return state.menu.items.filter(
    c => c.meta && c.meta.label === "Components"
  )[0];
};
const publicLayout = state => state.app.publicLayout;
const permissions = state => state.user.permissions;
const profile = state => state.app.me;
const reportList = state => state.report.report;
const isHasReport = state => state.report.hasNotificationFromReport;
const isLoadingReport = state => state.report.componentLoading;
const timezone = state => state.app.timezone;
// const currency = state => state.app.currency;
const imagePlaceholder = state => state.app.imagePlaceholder;
const setting = state => state.app.setting;

export {
  pkg,
  app,
  device,
  sidebar,
  effect,
  menuitems,
  componententry,
  publicLayout,
  permissions,
  profile,
  currency,
  tag,
  reportList,
  isHasReport,
  isLoadingReport,
  timezone,
  imagePlaceholder,
  setting
};
